import { defineMessages } from '@/i18n'

/** Тексты ленты AI-панели: вопрос прогона и индикатор генерации. */
export const messages = defineMessages({
  ru: {
    gateForbidden: 'Отвечать может только автор запуска.',
    gateNotFound: 'Вопрос не найден, обновите страницу.',
    gateOther: 'Не удалось отправить ответ, попробуйте ещё раз.',
    gateTextOnly: 'Этот вопрос ждёт текстового ответа — интерфейс пока не умеет его показать.',
    gateDeadline: (deadline: string) =>
      `Ответить до ${deadline} — потом запуск закроется сам, а нарисованные варианты всё равно будут оплачены.`,
    gateRejectedKept:
      'Невыбранные варианты остались в ваших файлах — к ним можно вернуться вручную.',
    gateExpired: 'Срок ответа истёк, запуск закрыт.',
    checkingStatus: 'Проверяю статус запуска…',
    progress: (subject: string, done: number, total: number) => `${subject}: ${done} из ${total}`,
    cantStop:
      'Запуск не остановить. Он продолжится, даже если уйти из редактора или закрыть вкладку.',
  },
  en: {
    gateForbidden: 'Only the person who started the run can answer.',
    gateNotFound: 'Question not found — refresh the page.',
    gateOther: 'Couldn’t send the answer — try again.',
    gateTextOnly: 'This question expects a text answer — the interface can’t show it yet.',
    gateDeadline: (deadline: string) =>
      `Answer by ${deadline} — after that the run closes on its own, and the generated variants are still charged.`,
    gateRejectedKept:
      'The variants you didn’t pick stay in your files — you can go back to them manually.',
    gateExpired: 'The answer deadline has passed — the run is closed.',
    checkingStatus: 'Checking run status…',
    progress: (subject: string, done: number, total: number) => `${subject}: ${done} of ${total}`,
    cantStop:
      'The run can’t be stopped. It continues even if you leave the editor or close the tab.',
  },
})
